import { gql } from "@apollo/client";
import { Garage } from "@App/types";

export interface GarageDaysQuery {
  garage: Garage;
}

export const GET_GARAGE_DAYS = gql`
    query getGarageDays(
        $organization: ID!,
        $garage: ID,
        $services: [ID],
        $startDate: DateTimeTz!,
        $endDate: DateTimeTz!,
        $brand: ID,
        $generation: ID,
        $motorization: ID,
        $gearbox: ID,
        $body: ID,
        $mileage: Int,
        $registrationDate: Date,
        $subRepairs: [String],
        $equipments: [String],
        $premiumServices: [ID]
    ) {
        garage(id: $garage) {
            id
            uuid
            days(
                input: {
                    organization: $organization,
                    from: $startDate,
                    to: $endDate,
                    duration:30,
                    calculation: {
                        services: $services
                        brand: $brand
                        generation: $generation
                        motorization: $motorization
                        mileage: $mileage
                        gearbox: $gearbox
                        body: $body
                        registration_date: $registrationDate
                        sub_repairs: $subRepairs
                        equipments: $equipments
                        premiumServices: $premiumServices
                    }
                }
            )
        }
    }
`;
